import TypesHelpers from './types.helpers';
import TypesInternationalization from './types.internationalization';
import TypesLanguageDicrionaryKeys from './types.language-dictionary-keys';

import dictionary from '../assets/dictionary.json';

const prettifyString = string => (
  `${string}`
  .replace(/([A-Z])|\.([a-z])/g, ' $1')
  .replace(/[_-]/g, '')
  .replace(/^./, str => str.toUpperCase())
  .replace(/Id/g, 'ID')
);

const Types = {
  ...TypesHelpers,
  ...TypesInternationalization,
  ...TypesLanguageDicrionaryKeys,
};

Object.assign(
  Types,
  Types.createValues('ROLE', [{
    id: 'ADMIN',
    label: 'Admin',
  }]),
  Types.createValues('CHANGE_LOG_ACTION', [{
    id: 'CREATE',
    label: 'Create',
  }, {
    id: 'PATCH',
    label: 'Update',
  }, {
    id: 'DELETE',
    label: 'Delete',
  }]),
  Types.createValues('CHANGE_LOG_TARGET_TYPE', [{
    id: 'Language',
    links: {
      ADMIN: '/languages',
    },
  }, {
    id: 'Settings',
    links: {
      //
    },
    getLabel: (label) => prettifyString(label),
  }, ...(
    [
      ['Device', '/devices'],
      ['Customer', '/customers'],
      ['Report', '/reports'],
    ].map(([label, archivePath]) => ({
      id: label,
      links: {
        '*': archivePath,
      },
    }))
  )].map((item) => {
    item.label = item.id;
    return item;
  })),
  Types.createValues('CSV_FORMAT', [{
    id: 'GENERAL',
    label: 'General',
    delimiters: {
      quote: '"',
      column: ',',
      row: '\n',
      decimal: '.',
    },
  }, {
    id: 'EUROPEAN',
    label: 'European',
    delimiters: {
      quote: '"',
      column: ';',
      row: '\n',
      decimal: ',',
    },
  }, {
    id: 'INTERNATIONAL',
    label: 'International',
    delimiters: {
      quote: '"',
      column: ',',
      row: '\n',
      decimal: '.',
    },
  }]),
);

Types.getIsLocalSubnet = (hostname) => (
  ['localhost', '127.0.0.1'].includes(hostname)
  || /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)
);

Types.FORBIDDEN_SLUGS = [
  ...Object.keys(Types.LANGUAGES_MAP),
  'admin',
  'api',
  'tracking',
  'orders',
  'order',
  'shop',
  'password-reset',
  'password-set',
  'password',
  'approve',
  'activate',
  'active',
  'signup',
  'signin',
  'checkout',
  'apple',
  'apple-pay',
  'google',
  'google-pay',
  'cart',
  'recover',
  'recovery',
  'blog',
  'cdn',
  'client',
  'clients',
  'help',
  'support',
  'status',
  'www',
  'store',
  'stores',
  'shop',
  'shops',
  'payment',
  'payments',
  'billing',
  'wallet',
  'shipping',
  'mail',
  'email',
  'smtp',
  'ftp',
  'webmail',
  'services',
  'community',
  'forum',
  'news',
  'update',
  'updates',
  'download',
  'downloads',
  'assets',
  'static',
  'offer',
  'offers',
  'portal',
  'portals',
  'dashboard',
  'account',
  'accounts',
  'secure',
  'ssl',
  'vpn',
  'careers',
  'job',
  'jobs',
  'legal',
  'privacy',
  'terms',
  'about',
  'info',
  'docs',
  'developer',
  'developers',
  'faq',
  'features',
  'stats',
  'statistics',
  'report',
  'reports',
  'analytics',
  'tracking',
  'track',
  'feedback',
  'promo',
  'promotions',
  'marketing',
  'sales',
  'discount',
  'discounts',
  'coupon',
  'coupons',
  'deal',
  'deals',
  'orders',
  'order',
  'shop',
  'shops',
  'product',
  'products',
  'password-reset',
  'password-set',
  'password',
  'approve',
  'activate',
  'active',
  'signup',
  'signin',
  'reseller',
  'referral',
  'checkout',
  'apple',
  'apple-pay',
  'google',
  'google-pay',
  'cart',
  'recover',
  'recovery',
  // Marketplaces english
  'fashion',
  'food',
  'electronics',
  'books',
  'sports',
  'beauty',
  'health',
  'toys',
  'jewelry',
  'home',
  'garden',
  'pets',
  'music',
  'movies',
  'games',
  'art',
  'crafts',
  'automotive',
  'baby',
  'office',
  // Marketplaces serbian
  'moda',
  'klopa',
  'elektronika',
  'knjige',
  'sport',
  'lepota',
  'zdravlje',
  'igracke',
  'nakit',
  'kuca',
  'basta',
  'ljubimci',
  'muzika',
  'filmovi',
  'igre',
  'umetnost',
  'rukotvorine',
  'automobili',
  'bebe',
  'kancelarija',
];

Types.COUNTRIES_DIAL_CODES = Types.COUNTRIES.reduce(
  (agr, country) => {
    country.dialCodes.forEach((dialCode, i) => {
      agr.push({
        value: dialCode,
        label: `+${dialCode} (${country.name})${i > 0 ? ` ${i}` : ''}`,
      });
    });
    return agr;
  },
  [],
);

Types.DICTIONARY_OBJECT = {
  ...dictionary,
};

Types.DICTIONARY = (Object.values(Types.DICTIONARY_OBJECT).reduce(
  (agr, group) => {
    agr.push(...group)
    return agr;
  },
  [],
));

Object.assign(Types, Types.createValues('PAGE_BLOCK_TYPE', [{
  id: 'TITLE',
  label: 'Title',
}, {
  id: 'TEXT',
  label: 'Text',
}, {
  id: 'IMAGE',
  label: 'Image',
}, {
  id: 'ACTION',
  label: 'Action',
}, {
  id: 'MODAL',
  label: 'Modal',
}]));

Types.CONSTANTS = {};

export default Types;
